var React = require('react');

function HeaderApplatTablet (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"header-appalt","d":"M-10946,877c48-42,85.021-46.375,164-42s176.992,53.992,338,51,266-51,266-51V758h-768Z","transform":"translate(10946 -758)","fill":"#87d4ff"}));
}

HeaderApplatTablet.defaultProps = {"width":"768","height":"128.126","viewBox":"0 0 768 128.126"};

module.exports = HeaderApplatTablet;

HeaderApplatTablet.default = HeaderApplatTablet;
